import { c as _c } from "react/compiler-runtime";
import { EntityPlacementCtaTypeEnum } from '@repo/contracts/marketplace/offers/enums';
import type { Offer } from '@repo/contracts/marketplace/offers/types';
import { css } from '@repo/pandacss/css';
import { CTASearchParams } from '@repo/platform-analytics/lib/ctaSearchParams';
import { FinishType } from '@repo/platform-analytics/types';
import { type CtaAnalyticsProps, CtaLink } from './CTA/CtaLink';
const productNameLinkClass = css({
  color: 'common.black',
  fontWeight: '[700]',
  fontSize: {
    base: '[calc(1.12385rem + 0.45872vw)]',
    _pcMobile: '[20px]'
  },
  lineHeight: '[1.3]',
  mt: '2',
  textDecoration: 'none',
  display: 'inline',
  _hover: {
    color: 'common.black',
    textDecoration: 'underline'
  },
  _focus: {
    borderRadius: '[4px]',
    color: 'common.black'
  },
  _pcMd: {
    fontSize: '[1.5rem]',
    lineHeight: '[1.33]'
  }
});
const cardHeaderWrapperClass = css({
  position: 'relative'
});
const cardHeaderTitleClass = css({
  m: '0',
  fontSize: 'inherit',
  fontWeight: '[inherit]'
});
export type CardHeaderProps = {
  link?: string;
  productName: string;
  checkedLabel?: string;
  uncheckedLabel?: string;
  analytics: CtaAnalyticsProps;
  offer: {
    id: string;
    cta?: Offer['cta'];
  };
};
export function CardHeader(t0) {
  const $ = _c(7);
  const {
    link,
    offer,
    productName,
    analytics
  } = t0;
  let t1;
  if ($[0] !== analytics || $[1] !== link || $[2] !== offer || $[3] !== productName) {
    t1 = link ? <CtaLink analytics={{
      ...analytics,
      linkType: analytics.finishType === FinishType.ExternalApplication ? "OFFER_NAME" : undefined
    }} type={analytics.finishType === FinishType.ExternalApplication ? "OFFER_NAME" : undefined} href={link} isReview={analytics.finishType === FinishType.InternalContent} className={productNameLinkClass} underline="hover" rel={offer.cta?.type === EntityPlacementCtaTypeEnum.ApplyNow ? "nofollow" : undefined} target="_blank" finishType={analytics.finishType ?? FinishType.ExternalApplication} parameterActions={offer.cta?.type === EntityPlacementCtaTypeEnum.ApplyNow || analytics.finishType === FinishType.ExternalApplication ? [CTASearchParams.MONETIZING, CTASearchParams.SHOPPING_FINISH] : []}>{productName}</CtaLink> : productName;
    $[0] = analytics;
    $[1] = link;
    $[2] = offer;
    $[3] = productName;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <div className={cardHeaderWrapperClass}><h3 className={cardHeaderTitleClass} data-testid="product-card-name">{t1}</h3></div>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}